import React, { createContext, useContext, useState, useMemo } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};

export const ThemeProvider = ({ children }) => {
    const [raikuMode, setRaikuMode] = useState(false);

    const theme = useMemo(() => (raikuMode ? {
        bg: '#050505',
        accent: '#c0fe38',
        accentDim: 'rgba(192, 254, 56, 0.15)',
        cardBg: '#111',
        text: '#c0fe38',
        textDim: 'rgba(192, 254, 56, 0.6)',
        border: '#ff9f1c',
        gold: '#ff9f1c',
        statusBarBg: '#ff9f1c',
        statusBarText: '#050505',
        panelBg: 'rgba(192, 254, 56, 0.15)',
        panelText: '#c0fe38',
        panelAccent: '#ff9f1c',
        panelHeaderText: '#050505',
    } : {
        bg: 'rgb(236, 236, 222)',
        accent: 'rgb(169, 56, 56)',
        accentDim: 'rgba(169, 56, 56, 0.3)',
        cardBg: '#34495e',
        text: 'rgb(252, 217, 157)',
        textDim: 'rgba(252, 217, 157, 0.6)',
        border: 'rgb(169, 56, 56)',
        gold: '#d97706',
        statusBarBg: 'rgb(169, 56, 56)',
        statusBarText: 'rgb(252, 217, 157)',
        panelBg: 'rgb(252, 217, 157)',
        panelText: 'rgb(169, 56, 56)',
        panelAccent: '#34495e',
        panelHeaderText: 'rgb(169, 56, 56)',
    }), [raikuMode]);

    const toggleRaikuMode = () => setRaikuMode(prev => !prev);

    return (
        <ThemeContext.Provider value={{ raikuMode, theme, toggleRaikuMode }}>
            {children}
        </ThemeContext.Provider>
    );
};
